<template>
    <div class="stream-url">
        <div class="stream-url__read" v-if="!isEdit">
            <a v-if="stream.url" class="stream-url__value" :href="stream.url" target="_blank">{{ stream.url }}</a>
            <Icon id="edit" @click="isEdit = true"/>
        </div>
        <EditText
            v-else
            class="stream-url__edit"
            v-model="editable"
            @cancel="cancel"
            @apply="apply"
            @paste="v => paste(v)"
        />
    </div>
</template>

<script>
import {mapState} from "vuex";
import EditText from "@common/vue/components/form/EditText";

export default {
    name: "StreamUrl",
    components: {EditText},
    data() {
        return {
            isEdit: false,
            editable: '',
        }
    },
    computed: {
        ...mapState({
            stream: state => state.planUrl.selectedStream,
        }),
    },
    watch: {
        'stream.url': function () {
            this.editable = this.stream.url || '';
        },
    },
    mounted() {
        this.editable = this.stream.url || '';
    },
    methods: {
        cancel() {
            this.editable = this.stream.url || '';
            this.isEdit = false;
        },
        paste(val) {
            this.editable = val;
        },
        apply() {
            this.$emit('error', '');
            this.$store.dispatch('updatePlanUrlStream', {
                streamId: this.stream.id,
                field: 'url',
                value: this.editable,
            })
                .then(r => this.isEdit = false)
                .catch(err => this.$emit('error', err.response.data.message));
        },
    }
}
</script>

<style lang="scss">
.stream-url {
    &__read {
        display: flex;
        align-items: center;
    }

    &__value {
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        font-weight: 400;
        font-size: 14px;
        text-decoration-line: underline;
        color: #30B68F;
        white-space: nowrap;
    }
}
</style>
